<script>
export default {
    components: {},
    computed: {},
    watch: {},
    data() {
        return {}
    },
    methods: {},
}
</script>

<template>
    <div>
        <h4>{{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }} Subscription</h4>
        <p>Unleash your inner racer with our {{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }} subscription plan! <strong>Get up to 50% off when you subscribe</strong> to monthly credit reloading—meaning more time behind the wheel for less. Credits can be used to book our ultra-realistic, high-end racing simulators, perfect for you and your friends. From Formula 1 to GT racing, our setups offer a fully immersive experience with Haptic Motion feedback.</p>
        <h4>FAQ</h4>
        <p>
            <ul>
                <li><strong>How does the subscription work?</strong> You buy credits at a discounted rate, up to 50% off!</li>
                <li><strong>Can I use credits for friends?</strong> Yes, share the experience by booking for others.</li>
                <li><strong>Do credits expire?</strong> Yes, use 'em or lose 'em!</li>
                <li><strong>What simulators can I use?</strong> You can use credits on any simulator. You are simply selecting the amount of credits you want to replenish every month.</li>
                <li><strong>How long must I keep my subscription active?</strong> If you cancel your subscription within 2 months, you will be charged full price for the reservations you've made.</li>
            </ul>
        </p>
    </div>
</template>

<style lang="scss" scoped>
</style>
